// extracted by mini-css-extract-plugin
module.exports = {"circle":"circle__JQkAl","completed":"completed__6PAmh","has-notification":"has-notification__2qA4t","in-progress":"in-progress__CdO21","not-started":"not-started__WE8+U"};